export const DISCRIMINATORS = {
    Load: "load",
    StartCheckout: "startCheckout",
    PromotionCode: "PromotionCode"
};
